import { render, staticRenderFns } from "./EditProductCategoryComponent.vue?vue&type=template&id=68a503c4&scoped=true"
import script from "./EditProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./EditProductCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a503c4",
  null
  
)

export default component.exports